import { render, staticRenderFns } from "./campaign-extensions.vue?vue&type=template&id=168f3b58&scoped=true&"
import script from "./campaign-extensions.vue?vue&type=script&lang=js&"
export * from "./campaign-extensions.vue?vue&type=script&lang=js&"
import style0 from "./campaign-extensions.vue?vue&type=style&index=0&id=168f3b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168f3b58",
  null
  
)

export default component.exports